import { connect } from 'react-redux';
import { compose } from 'redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import {
  closeResetPasswordWithTokenDialog,
  setConfirmationPassword as setConfirmationPasswordAction,
  setNewPassword as setNewPasswordAction,
  submit,
  trackAdobeAnalyticsError,
} from './ResetPasswordWithTokenDialogActions';
import { openForgotPasswordDialog } from '../LoginActions';
import ResetPasswordWithTokenDialog from './ResetPasswordWithTokenDialog';
import ResetPasswordWithTokenDialogReducer from './ResetPasswordWithTokenDialogReducer';
import { resetPasswordWithTokenDialogReducerKey } from './ResetPasswordWithTokenDialogConstants';
import {
  confirmationPassword as confirmationPasswordSelector,
  responseStatus as responseStatusSelector,
  newPassword as newPasswordSelector,
  errorDetails as errorDetailsSelector,
} from './ResetPasswordWithTokenDialogSelectors';

const mapStateToProps = (state) => ({
  responseStatus: responseStatusSelector(state),
  newPassword: newPasswordSelector(state),
  confirmationPassword: confirmationPasswordSelector(state),
  errorDetails: errorDetailsSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  close: () => dispatch(closeResetPasswordWithTokenDialog()),
  trackAdobeAnalyticsError: (errors, prefix) => trackAdobeAnalyticsError(errors, prefix),
  setNewPassword: (password) => dispatch(setNewPasswordAction(password)),
  setConfirmationPassword: (password) => dispatch(setConfirmationPasswordAction(password)),
  openForgotPasswordDialog: () => dispatch(openForgotPasswordDialog()),
  submit: () => dispatch(submit(ownProps.token)),
});

export default compose(
  withCombinedRouteParams,
  withReducer(resetPasswordWithTokenDialogReducerKey, ResetPasswordWithTokenDialogReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(ResetPasswordWithTokenDialog);
